// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2tBVo","label":"LabeledBox_label__2VwRa"};